import { useEffect } from 'react';
import { useAppSelector } from '../redux/hooks';
import { getFontUtilities, getFontFamily } from '../utils/fonts';
import { hexToRgb, setCssVar } from '../utils/style';

export const useAppStyle = () => {
  const theme = useAppSelector((state) => state.theme);
  
  // Set CSS variables (replaces StyleProvider functionality)
  useEffect(() => {
    // Set brand color CSS variable
    if (theme.primaryColor) {
      const primaryRgb = hexToRgb(theme.primaryColor);
      if (primaryRgb) {
        setCssVar('--color-brand', primaryRgb);
      }
    }
    
    // Set font family CSS variable
    if (theme.fontKey) {
      const fontFamily = getFontFamily(theme.fontKey);
      if (fontFamily) {
        setCssVar('--font-family', fontFamily);
      }
    }
  }, [theme.primaryColor, theme.fontKey]);

  // Return font utilities for direct use
  const fontUtilities = getFontUtilities(theme.fontKey);
  
  return {
    fontFamily: fontUtilities.tailwindFontClass,
    primaryColor: theme.primaryColor,
    fontKey: theme.fontKey
  };
};
